import { AxiosResponse } from 'axios';
import { backendApiInstance } from './backendApiInstance';
import { IGetInvitationsParams, IGetInvitationsResponse } from '../redux/invite/inviteSlice';

export async function getPermissions(): Promise<AxiosResponse> {
  return backendApiInstance.get('permissions');
}
export async function inviteSubordinate(payload: { emails: string[]; permissions: number[] }): Promise<AxiosResponse> {
  return backendApiInstance.post('subordinates/invite', payload);
}
export async function validateInvite(token: String): Promise<AxiosResponse> {
  return backendApiInstance.post(`subordinates/invite/validate/${token}`);
}
export async function recallInvite(token: String): Promise<AxiosResponse> {
  return backendApiInstance.post(`subordinates/invite/recall/${token}`);
}
export async function getInvites({ page, limit, sortBy, sortOrder }: IGetInvitationsParams): Promise<AxiosResponse> {
  return backendApiInstance.get('/subordinates/invitations', {
    params: { page, limit, sortBy, sortOrder },
  });
}
export async function recalledInvitation(invitationId: string): Promise<AxiosResponse> {
  return backendApiInstance.post(`subordinates/invitation/${invitationId}/recall`);
}
